module.exports = __webpack_public_path__ + "img/forwardzhuanqian.9abf6463.svg";